import { createFileRoute } from '@tanstack/react-router'

import MembershipPrivilegesPage from '@/views/loyalty/membership-privileges/membership-privileges.page'

export const Route = createFileRoute(
  '/phong-nha/loyalty/membership-privileges',
)({
  component: MembershipPrivilegesPage,
})

